import type { SocialLink } from '../types';

export const socialLinks: SocialLink[] = [
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/viral-chovatiya-b66a751a0',
    icon: 'Linkedin',
  },
];

export const contactInfo = {
  email: 'vchovatiya992@gmail.com',
  phone: '+91 8758921153',
  location: 'Surat, Gujarat, India',
};
